import { defineWidgetSettings } from "@nexus/widget-sdk";

/** What an author sets on the top detected hosts. */
export const settings = defineWidgetSettings({
  id: "top-detected-hosts",
  properties: {
    hostSource: {
      type: "string",
      title: "Host source",
      default: "armada",
      oneOf: [
        { const: "armada", title: "Armada endpoints" },
        { const: "hermes", title: "Hermes ticket IP owner" },
      ],
      "x-ui": { category: "data", order: 20, keepDefault: true },
    },
    percentagePrecision: {
      type: ["string", "integer"],
      title: "Percentage precision",
      default: "auto",
      oneOf: [
        { const: "auto", title: "Adaptive" },
        { const: 0, title: "Whole percent" },
        { const: 1, title: "One decimal" },
      ],
      "x-ui": { category: "display", order: 10, keepDefault: true },
    },
  },
});
